/**
 * @generated SignedSource<<09ebacc47c2cea47b913ac85197520a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardCard_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardCardActions_project">;
  readonly " $fragmentType": "BoardCard_project";
};
export type BoardCard_project$key = {
  readonly " $data"?: BoardCard_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardCard_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardCardActions_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9c19a343771e205fae0ee649688bf9c8";

export default node;
